const SENSITIVE_KEY_PATTERNS = [
  /username/i,
  /password/i,
  /email/i,
  /credential/i,
  /secret/i,
  /token/i,
  /captcha/i,
  /mfa/i,
  /login.?details/i,
  /authorization/i,
  /api.?key/i,
]

const MAX_DEPTH = 10
const MAX_NODES = 1000

const isSensitiveKey = (key: string): boolean =>
  SENSITIVE_KEY_PATTERNS.some(p => p.test(key))

export default function redactSensitive(value: unknown): unknown {
  const seen = new WeakSet<object>()
  const counter = { n: 0 }

  const walk = (v: unknown, depth: number): unknown => {
    if (counter.n++ > MAX_NODES) {
      return '[REDACTED:size]'
    }

    if (depth > MAX_DEPTH) {
      return '[REDACTED:depth]'
    }

    if (v === null || typeof v !== 'object') {
      return v
    }

    if (seen.has(v as object)) {
      return '[REDACTED:cycle]'
    }

    seen.add(v as object)

    if (Array.isArray(v)) {
      const arr: unknown[] = []
      for (const item of v) {
        if (counter.n > MAX_NODES) {
          arr.push('[REDACTED:size]')
          break
        }
        arr.push(walk(item, depth + 1))
      }
      seen.delete(v as object)
      return arr
    }

    const out: Record<string, unknown> = {}
    for (const [k, val] of Object.entries(v as object)) {
      if (counter.n > MAX_NODES) {
        out['[REDACTED:size]'] = '[REDACTED:size]'
        break
      }
      out[k] = isSensitiveKey(k) ? '[REDACTED]' : walk(val, depth + 1)
    }
    seen.delete(v as object)

    return out
  }

  return walk(value, 0)
}
